// === Exported Global Control Functions ===
/**
 * Opens the account settings modal if the component is in modal mode.
 * Dispatches a global event that the component listens to.
 */
export function openMemberManagementModal() {
  document.dispatchEvent(
    new CustomEvent("open-member-management", {
      bubbles: true,
      composed: true,
    }),
  );
}

/**
 * Closes the account settings modal if the component is in modal mode.
 * Dispatches a global event that the component listens to.
 */
export function closeMemberManagementModal() {
  document.dispatchEvent(
    new CustomEvent("close-member-management", {
      bubbles: true,
      composed: true,
    }),
  );
}
